export default __webpack_public_path__ + "static/media/team6.2945209c.png";